import type { IconSvgObject } from './types';

const RupeeIcon: IconSvgObject = [
  ["path", { d: "M6 3H9C11.7614 3 14 5.23858 14 8C14 10.7614 11.7614 13 9 13H6L15 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 3H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 8H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default RupeeIcon;
